export default __webpack_public_path__ + "static/media/numberswarmup_locked.edb98d8c.svg";